import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import colors from '@src/components/common/Availability/AvailabilityMap/colors';
import USAMap from '@src/vendorMod/ReactUSAMap';


import MapLegend from './AvailabilityMapLegend';
import AvailabilityToolTips from './AvailabilityToolTips';

import './AvailabilityMap.scss';

const AvailabilityMap = (props) => {
    const {
        availability,
        allItems,
        currentItem,
    } = props;
    const states = {};
    const legend = [];

    const [target, setTarget] = React.useState(null);
    const [stateId, setStateId] = React.useState('');

    availability.forEach((item) => {
        legend.push({
            title: item.title,
            color: item.color,
        });
        if (!item.states) {
            return;
        }

        item.states.forEach((state) => {
            if (state === 'DC') {
                state = 'DC2';
            }

            states[state] = { fill: item.color };
        });
    });

    const onClickHandler = React.useCallback((clickEvent) => {
        const thisTarget = clickEvent.target;
        const stateId = thisTarget.dataset.name;
        const parentNode = thisTarget.parentNode;
        const statesPaths = parentNode.getElementsByTagName('path');
        const dcPaths = parentNode.getElementsByClassName('DC2');

        if (statesPaths) {
            if (!currentItem) {
                for (let i = 0; i < statesPaths.length; ++i) {
                    statesPaths[i].setAttribute('style', `fill: ${colors.notAvailable}`);
                }

                for (let i = 0; i < dcPaths.length; ++i) {
                    dcPaths[i].setAttribute('style', `fill: ${colors.notAvailable}`);
                }

                thisTarget.setAttribute('style', `fill: ${colors.available}`);
            }

            setTarget(thisTarget);
            setStateId(stateId);
            return;
        }

        setTarget(null);
        setStateId('');
    }, [setTarget, setStateId, currentItem]);

    React.useEffect(() => {
        if (!allItems) {
            return;
        }

        document.addEventListener('mousedown', onClickHandler);
        document.addEventListener('touchstart', onClickHandler);

        return () => {
            document.removeEventListener('mousedown', onClickHandler);
            document.addEventListener('touchstart', onClickHandler);
        };
    }, [allItems, onClickHandler]);

    return (
        <Row className="map-container-row">
            <Col className="text-center map-container-col">
                <MapLegend legend={legend} />
                <USAMap customize={states} />
                {
                    stateId && currentItem
                    && (
                        <AvailabilityToolTips
                            target={target}
                            stateId={stateId}
                            currentItem={currentItem}
                            availability={availability}
                        />
                    )
                }
            </Col>
        </Row>
    );
};

AvailabilityMap.propTypes = {
    availability: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
        states: PropTypes.arrayOf(PropTypes.string),
    })).isRequired,
    allItems: PropTypes.arrayOf(PropTypes.object),
    currentItem: PropTypes.object,
};

export default React.memo(AvailabilityMap);
